import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { decaturALConfig } from "./data";

export default function DecaturALPage() {
  return <CityPageTemplate config={decaturALConfig} />;
}